import EventBus from '../../../shared/js/wirebox/event-bus'
import '../../../shared/js/wirebox/utilities/scroll-to-target'
import jQuery from 'jquery'

const ScrollOnCollapse = {
    
    init() {
        
        jQuery(document).on('shown.bs.collapse', '.scroll-on-collapse', (event) => {
            
            let
                dropdown = jQuery(event.target),
                scrollTarget = dropdown.data('scroll-target')
            
            EventBus.publish('scroll-to-target', {
                offset: jQuery('#header-nav').outerHeight(),
                target: scrollTarget ? jQuery(scrollTarget) : dropdown
            })
            
        })
        
    }
    
}

EventBus.subscribe('init-modules', ScrollOnCollapse.init)

export default ScrollOnCollapse
